@if (updateInfo()) {
  <div class="ub" [class.ub--required]="updateInfo()?.isRequired" [class.ub--error]="state() === 'error'">
    <div class="ub__icon-area">
      @switch (state()) {
        @case ('available') {
          <div class="ub__icon ub__icon--update">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z" clip-rule="evenodd"/>
            </svg>
          </div>
        }
        @case ('downloading') {
          <div class="ub__icon ub__icon--download">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
              <path d="M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z"/>
              <path d="M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z"/>
            </svg>
          </div>
        }
        @case ('ready') {
          <div class="ub__icon ub__icon--ready">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/>
            </svg>
          </div>
        }
        @case ('error') {
          <div class="ub__icon ub__icon--error">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
            </svg>
          </div>
        }
      }
    </div>

    <div class="ub__body">
      @switch (state()) {
        @case ('available') {
          <div class="ub__row">
            <div class="ub__info">
              <span class="ub__title">
                Version {{ updateInfo()?.version }} is available
                @if (updateInfo()?.isRequired) {
                  <span class="ub__badge ub__badge--required">Required</span>
                }
              </span>
              <span class="ub__subtitle">A new version of InfinitForm is ready to download</span>
            </div>
            <div class="ub__actions">
              <button class="ub__btn ub__btn--text" (click)="showReleaseNotes.set(!showReleaseNotes())">
                {{ showReleaseNotes() ? 'Hide Notes' : 'Release Notes' }}
              </button>
              <button class="ub__btn ub__btn--primary" (click)="startDownload()">Download Update</button>
              @if (!updateInfo()?.isRequired) {
                <button class="ub__btn ub__btn--ghost" (click)="dismiss()">Dismiss</button>
              }
            </div>
          </div>
          @if (showReleaseNotes()) {
            <div class="ub__notes">{{ updateInfo()?.releaseNotes }}</div>
          }
        }

        @case ('downloading') {
          <div class="ub__row">
            <div class="ub__info">
              <span class="ub__title">Downloading v{{ updateInfo()?.version }}...</span>
              <span class="ub__subtitle">
                {{ downloadProgress()?.percent }}% complete
                @if (downloadSpeed()) { &middot; {{ downloadSpeed() }} }
              </span>
            </div>
            <button class="ub__btn ub__btn--ghost" (click)="cancelDownload()">Cancel</button>
          </div>
          <div class="ub__progress">
            <div class="ub__progress-fill" [style.width.%]="downloadProgress()?.percent ?? 0"></div>
          </div>
        }

        @case ('ready') {
          <div class="ub__row">
            <div class="ub__info">
              <span class="ub__title">Ready to install v{{ updateInfo()?.version }}</span>
              <span class="ub__subtitle">The update has been downloaded and verified</span>
            </div>
            <div class="ub__actions">
              <button class="ub__btn ub__btn--primary" (click)="installUpdate()">Install Now</button>
              <button class="ub__btn ub__btn--ghost" (click)="dismiss()">Later</button>
            </div>
          </div>
        }

        @case ('error') {
          <div class="ub__row">
            <div class="ub__info">
              <span class="ub__title">Update failed</span>
              <span class="ub__subtitle">{{ errorMessage() }}</span>
            </div>
            <div class="ub__actions">
              <button class="ub__btn ub__btn--primary" (click)="startDownload()">Retry</button>
              <button class="ub__btn ub__btn--ghost" (click)="dismiss()">Dismiss</button>
            </div>
          </div>
        }
      }
    </div>
  </div>
}
